import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

// FCM service worker: registered in app.module.ts loadConfig() after /admin/config loads.
// Runs when notificationsDisabled=false and production. Set NOTIFICATIONS_DISABLED=false on backend to enable.
